import React from 'react'
import { Route, useRouteMatch } from 'react-router'

import QueueStateProvider from '../../providers/QueueStateProvider'
import ChatEditStateProvider from '../../providers/ChatEditStateProvider'
import AddRemoveParticipantProvider from '../../providers/AddRemoveParticipantProvider'
import OwnerProvider from '../../providers/OwnerProvider'
import VerificationProvider from '../../providers/VerificationProvider'
import MetaProvider from '../../providers/MetaProvider'
import EditProvider from '../../providers/EditProvider'
import CustomerProvider from '../../providers/CustomerProvider'

import ClientChats from '../../pages/ClientChats'
import MobileClientChat from '../../pages/ClientChats/Mobile/MobileClientChats'

import { useBreakpoint } from '../../providers/BreakpointProvider'

const ClientChatsRoute = () => {
  const { path } = useRouteMatch()
  const { down767: onMobile } = useBreakpoint()

  return (
    <Route
      path={path}
      render={() => (
        <QueueStateProvider>
          <ChatEditStateProvider>
            <AddRemoveParticipantProvider>
              <OwnerProvider>
                <VerificationProvider>
                  <MetaProvider>
                    <EditProvider>
                      <CustomerProvider>
                        {onMobile ? <MobileClientChat /> : <ClientChats />}
                      </CustomerProvider>
                    </EditProvider>
                  </MetaProvider>
                </VerificationProvider>
              </OwnerProvider>
            </AddRemoveParticipantProvider>
          </ChatEditStateProvider>
        </QueueStateProvider>
      )}
    />
  )
}

export default ClientChatsRoute
